import { useQuery } from "@tanstack/react-query";
import axiosInstance from "@/lib/axios";
import { getQualsByLead } from "@/config/endpoints";
import { queryClient } from "@/lib/queryClient";

export default function useQualificationByLead(leadId: string) {
  const query = useQuery({
    queryKey: ["qualification-by-lead"],
    queryFn: async () => {
      const res = await axiosInstance.get(
        getQualsByLead.replace(":leadId", leadId)
      );
      return res.data;
    },
  });

  return {
    quals: query?.data?.qualifications,
    result: query?.data?.result,
    isLoading: query.isLoading,
    error: query.error,
    refetch: query.refetch,
  };
}
export function refetchLeadQuals() {
  queryClient.invalidateQueries({ queryKey: ["qualification-by-lead"] });
}
